import { route, tag, type PageTour } from '../pageTour';

export const siteSettingsTour: PageTour = {
  id: 'page-site-settings',
  version: 1,
  title: 'Site Settings',
  summary: 'This site\'s general, storage and retention settings.',
  match: route('/settings'),
  steps: [
    {
      target: tag('settings-sections'),
      title: 'Settings sections',
      description:
        'Settings here belong to the selected site, not the whole platform. Pick a section — General, Storage, License or Camera tags — to see and change it.',
      side: 'right',
    },
    {
      target: tag('settings-site'),
      title: 'Site details',
      description: 'The site’s status, software version, connection to the cloud and how many people are watching its video.',
      side: 'bottom',
    },
    {
      target: tag('settings-site-only'),
      title: 'Changed on the site only',
      description:
        'A few settings, such as the cloud connection, license upload and backups, can only be changed on the site’s own screen, for safety.',
      side: 'top',
    },
    {
      target: tag('settings-integrations'),
      title: 'Integrations',
      description: 'Connect this site to an existing video management system or a third-party analytics tool.',
      side: 'right',
    },
  ],
};
